/**
 * header-height.js
 * Garde --header-height à jour sur :root avec la hauteur réelle de
 * #main-header (position: fixed, cf. layout/_header.scss), pour que
 * `scroll-margin-top: var(--header-height)` compense son chevauchement
 * lors d'un saut d'ancre (#id).
 *
 * La hauteur du header est fluide/responsive (padding en vw, colonne vs
 * ligne selon breakpoint) : pas de constante SCSS possible, on la mesure.
 * #main-header vit hors de #main (jamais remplacé par le routeur ajax),
 * donc un seul appel au chargement de la page suffit.
 */

function setHeaderHeight(height) {
  document.documentElement.style.setProperty('--header-height', `${height}px`)
}

export function initHeaderHeightSync() {
  const header = document.getElementById('main-header')
  if (!header) return

  const update = () => setHeaderHeight(header.offsetHeight)
  update()

  if (typeof ResizeObserver === 'undefined') {
    window.addEventListener('resize', update)
    return
  }
  new ResizeObserver(update).observe(header)
}
